import { breakpoints } from "./breakpoints";
import { dark as darkColors, light as lightColors } from "./colors";
import { radii } from "./radii";
import { shadows } from "./shadows";
import { space } from "./space";
import { typography } from "./typography";
export const light = {
    name: "light",
    breakpoints,
    colors: lightColors,
    font: typography,
    radii,
    shadows,
    space,
};
export const dark = Object.assign(Object.assign({}, light), { colors: darkColors, name: "dark" });
export default light;
